<template>
  <section class="section">
    <img class="leaf-1" src="@/assets/images/leaves/l2.png"/>
    <div class="container items-center">
      <h3 class="section__h3 mb-5">Privacy Policy</h3>
      <p class="section__p mb-base">GetBoarded is founded on the principle of helping people build and manage their identities. We know that you care about how your personal information is used and shared, and we take your privacy very seriously. By visiting the GetBoarded website, you are accepting the practices outlined in this policy.</p>
      <img class="leaf-2" src="@/assets/images/leaves/l7.png"/>
      <div>
        <vx-card class="mb-base items-left" no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">Information Collected by GetBoarded</h5>
              <p class="mb-5">We only collect publically available personal information that is relevant to the purpose of setting your profile on our website. This information allows us to provide you with a customized and efficient experience. We collect the following types of information from you:</p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>We collect information to make GetBoarded website easier for you to customize and launch your page.</p>
            </vs-col>
          </vs-row>
        </vx-card>

        <vx-card class="mb-base items-left"  no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">Information You Provide to Us</h5>
              <p class="mb-5">We receive and store information you enter on our website or provide to us in any other way. You can choose not to provide us with certain information, but then you may not be able to take advantage of many of our special features.</p>
              <p class="mb-5"><span class="font-bold">Registration:</span> Our application is currently built on Linked In public APIs. We gather publically available data through the OAuth and use the data to maintain your account. In order for you to use GetBoarded services you must register with your data. You may re-sync the data or clear our database easily by using the re-sync option in your profile.</p>
              <p class="mb-5"><span class="font-bold">User Profile:</span> To allow you to express yourself beyond just the information collected during login, we enable you to provide additional information, such as a bio, favorite URLs, and instant messaging IDs. In addition, you may choose to include photos of yourself in your profile. As indicated below, in the section titled "Sharing Your Information", you can control how your information is displayed and used.</p>
              <p class="font-bold mb-5">Automatic Information:</p>
              <p class="mb-5">We receive and store certain types of information whenever you interact with us. GetBoarded and its authorized agents automatically receive and record certain "traffic data" on their server logs from your browser including your IP address, GetBoarded cookie information, and the page you requested. GetBoarded uses this traffic data to help diagnose problems with its servers, analyze trends and administer the website.</p>
              <p class="mb-5">GetBoarded may collect and, on any page, display the total counts that page has been viewed. This includes User Profile pages.</p>
              <p class="mb-5">Many companies offer programs that help you to visit websites anonymously. While GetBoarded will not be able to provide you with a personalized experience if we cannot recognize you, we want you to be aware that these programs are available.</p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>We collect your registration and user profile data. Our servers also collect log information used to make the website faster and better.</p>
            </vs-col>
          </vs-row>
        </vx-card>

        <vx-card class="mb-base items-left" no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">E-mail Communications</h5>
              <p class="mb-5">GetBoarded is very concerned about your privacy and we will never provide your email address to a third party without your explicit permission, as detailed in the "Sharing Your Information" section below. GetBoarded may send out e-mails with GetBoarded-related news, products, offers, surveys or promotions. You may also receive notification e-mails from GetBoarded, which inform you of actions (e.g. friend requests, peer reviews, job notifications) that have been performed on the site. Please note that in all cases you will continue to receive all system e-mails (e.g. those regarding forgotten user passwords) and legal notices (e.g. updates to our policies) from us.</p>
              <p class="mb-5">If you do not want to receive e-mail from us, please visit the Email Preferences section of your User Profile and/or follow the instructions contained in the unwanted e-mail message.</p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>We will send you emails based on your profile settings. From time to time, we may send emails to all our users.</p>
            </vs-col>
          </vs-row>
        </vx-card>

        <vx-card class="mb-base items-left" no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">Cookies</h5>
              <p class="mb-5">Cookies are alphanumeric identifiers that we transfer to your computer's hard drive through your Web browser to enable our systems to recognize your browser and tell us how and when pages in our website are visited and by how many people. GetBoarded cookies do not collect personal information, and we do not combine information collected through cookies with other personal information to tell us who you are or what your screen name or e-mail address is.</p>
              <p class="mb-5">The 'help' portion of the toolbar on the majority of browsers will direct you on how to prevent your browser from accepting new cookies, how to command the browser to tell you when you receive a new cookie, or how to fully disable cookies. We recommend that you leave the cookies activated because cookies allow you to use some of GetBoarded's features. Some of our business partners, like our advertisers, may use cookies on our website. We have no access to, or control over, these cookies.</p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>To remember you, our system will give you a cookie. It's safe.</p>
            </vs-col>
          </vs-row>
        </vx-card>

        <vx-card class="mb-base items-left" no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">Sharing Your Information</h5>
              <p class="mb-5">Because GetBoarded enables people to discover and share profiles with one another, information about the people who use GetBoarded is an integral part of the GetBoarded experience. Rest assured that we neither rent nor sell your personal information to anyone and that we will share your personal information as described below.</p>
              <p class="mb-5"><span class="font-bold">GetBoarded Personnel:</span> GetBoarded personnel and authorized consultants and/or contractors may have access to user information if necessary in the normal course of GetBoarded business.</p>
              <p class="mb-5"><span class="font-bold">Business Transfers:</span> In some cases, we may choose to buy or sell assets. In these types of transactions, user information is typically one of the business assets that is transferred. Moreover, if GetBoarded, or substantially all of its assets, were acquired, user information would be one of the assets that is transferred.</p>
              <p class="mb-5"><span class="font-bold">Protection of GetBoarded and Others:</span> We may release personal information when we believe in good faith that release is necessary to comply with a law; to enforce or apply our Terms of Use and other policies; or to protect the rights, property, or safety of GetBoarded, our employees, our users, or others. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction.</p>
              <p class="mb-5"><span class="font-bold">User Profile information:</span> Information collected during registration and subsequent visits, such as your full name and location, may be displayed to other GetBoarded users in your User Profile. The User Profile is the area on GetBoarded where we allow you to tell other GetBoarded users about yourself. You may control what personal information is displayed in your User Profile by visiting the Settings section of your User Profile.</p>
              <p class="mb-5"><span class="font-bold">Followers' Activity:</span> Much like other online social networks, GetBoarded allows non-followers to browse your followers activity.</p>
              <p class="mb-5"><span class="font-bold">Syndication:</span> GetBoarded allows for the RSS syndication of all of its public content within the GetBoarded website.</p>
              <p class="mb-5"><span class="font-bold">With Your Consent:</span> Except as noted above, we will contact you when your personal information is shared with third parties or used for a purpose incompatible with the purpose(s) for which it was originally collected, and you will be able to opt out to prevent the sharing of this information.</p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>We do not sell your information to anyone. However, we will show publicly available information to other users and may release other information to authorities where required by law.</p>
            </vs-col>
          </vs-row>
        </vx-card>

        <vx-card class="mb-base items-left" no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">Ways to Control Display and Use Information</h5>
              <p class="mb-5">As stated previously, you can always opt not to disclose information, but then you may be unable to use certain features on our website.</p>
              <p class="mb-5"> By visiting your User Profile, you can correct, amend, add or delete personal information on our website.</p>
              <p class="mb-5"> If you do not wish to receive e-mail from us or other GetBoarded users, please visit the Settings of your User Profile and/or follow the instructions contained in the unwanted e-mail message.</p>
              <p class="mb-5"> However, please note that you will continue to receive all system e-mails (e.g. those regarding forgotten user passwords) and legal notices (e.g. updates to our policies) from us.</p>
              <p class="mb-5"> As explained earlier, the "help" portion of the toolbar on the majority of browsers will direct you on how to prevent your browser from accepting new cookies, how to command the browser to tell you when you receive a new cookie, or how to fully disable cookies. Please note, however, that if your browser does not accept cookies, you will not be able to take advantage of some of our attractive features.</p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>You can choose not to share information with us, but your experience of the site may be limited. However, until your account is deleted, you may receive all system emails.</p>
            </vs-col>
          </vs-row>
        </vx-card>

        <vx-card class="mb-base items-left" no-shadow card-background="#F7F8F9">
          <vs-row vs-justify="space-between">
            <vs-col vs-justify="center" vs-w="7">
              <h5 class="mb-2">Analytics</h5>
              <p class="mb-5">GetBoarded collects and stores your anonymous data using Google Analytics and improves its services. Analytics is one of the major offerings that is integrated in our service for tracking your user profile and your job campaigning. This information is shared with you to give you a control over your resume.</p>
              <p class="mb-5 text-priamry"><a href="#">To opt out of sending GA data click here.</a></p>
            </vs-col>
            <div class="vl"></div>
            <vs-col vs-justify="center" vs-w="4">
              <h5 class="mb-2">Basically</h5>
              <p>We do analytics and we provide the same as a service to you.</p>
            </vs-col>
          </vs-row>
        </vx-card>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "PrivacyPolicy"
  }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }

  section {
    padding: 10rem;
    background: #FFFFFF;
    position: relative;
  }
  section p, section ul li{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 26px;
    color: #848199;
  }

  .vl {
    border-left: 2px solid lightgray;
    display: flex; 
    opacity: 1;
  }

  .leaf-2 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .leaf-1 {
    position: absolute;
    right: 0;
    top: 0;
    width: 800px;
  }

  /*===============================================*/
  /* OUR MISSION	 						 */
  /*===============================================*/

  .section__h3 {
    margin-top: 5rem!important;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: center;
    color: #231D4F;
  }
  .section__p {
    margin-bottom: 5rem!important;
    width: 80%;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    /* or 150% */
    text-align: center;
    color: #848199;
  }
  .truncate {
    width: 80%;
    white-space: normal !important;
    margin-left: 1.5rem;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 10rem 2rem;
      background: #FFFFFF;
    }
    .section__p {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .leaf-1, .leaf-2 {
      width: -webkit-fill-available;
      width: -moz-available;
    }
  }
</style>
